import { payments } from "../actions/payment.actions";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";

const useOneTimePayment = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [liveMode, setLiveMode] = useState(true);
    let getOrginDomainUrl = window.location.origin;
    useEffect(() => {
        if (["https://tviloginstagingui.tripvalet.com", "http://localhost:3000"].includes(getOrginDomainUrl)) {
            setLiveMode(false);
        }
    }, [getOrginDomainUrl]);

    let priceJSON = {
        "status": true,
        "data": 947,
        "metadata": {
            "id": (liveMode) ? "price_1N6bbaIB7ByDDUZGTbMeJjqh" : "price_1N6r5qIB7ByDDUZGycdREpu1",
            "object": "price",
            "active": true,
            "billing_scheme": "per_unit",
            "created": 1683819634,
            "currency": "usd",
            "custom_unit_amount": null,
            "livemode": liveMode,
            "lookup_key": null,
            "metadata": {},
            "nickname": "TVI 12M",
            "product": (liveMode) ? "prod_NsMKjiK25jqnby" : "prod_NscKu3yQbLAvu3",
            "recurring": {
                "aggregate_usage": null,
                "interval": "year",
                "interval_count": 1,
                "meter": null,
                "trial_period_days": null,
                "usage_type": "licensed"
            },
            "tax_behavior": "unspecified",
            "tiers_mode": null,
            "transform_quantity": null,
            "type": "recurring",
            "unit_amount": 94700,
            "unit_amount_decimal": "94700",
            "productObject": {
                "id": (liveMode) ? "prod_NsMKjiK25jqnby" : "prod_NscKu3yQbLAvu3",
                "object": "product",
                "active": true,
                "attributes": [],
                "created": 1683819634,
                "default_price": (liveMode) ? "price_1N6bbaIB7ByDDUZGTbMeJjqh" : "price_1N6r5qIB7ByDDUZGycdREpu1",
                "description": "Annual Membership (2023)",
                "features": [],
                "images": [],
                "livemode": liveMode,
                "marketing_features": [],
                "metadata": {},
                "name": "TVI 12 Month Membership",
                "package_dimensions": null,
                "shippable": null,
                "statement_descriptor": "TVI 12 Mon",
                "tax_code": null,
                "tax_details": null,
                "type": "service",
                "unit_label": null,
                "updated": 1779296174,
                "url": null
            }
        }
    }

    const setUpPayment = () => {
        let product = {
            product_id: priceJSON?.metadata?.productObject?.id,
            name: priceJSON?.metadata?.productObject?.name,
            price: priceJSON?.data,
            price_id: priceJSON?.metadata?.id,
            initialPrice: priceJSON.data,
            priceObject: priceJSON.metadata,
        };

        dispatch(payments.setProduct(product));
    }

    return {
        setUpPayment
    }

}

export default useOneTimePayment